import {
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import type { PromptCardSource } from './PromptCardSource';
import type { State } from './State';
import { store } from './store';

export const usePromptCardSendTrackingActions: HookActionsFunction<
	BoundActions<
		State,
		{
			setPromptCardSource: (
				source: PromptCardSource | null,
			) => ({ setState }: StoreActionApi<State>) => void;
			/**
			 * Returns the current prompt card source (if any) and clears it.
			 * Call this when the user sends a message to determine if they sent a prompt card as-is or tweaked it.
			 */
			takePromptCardSource: () => ({
				setState,
				getState,
			}: StoreActionApi<State>) => PromptCardSource | null;
		}
	>
> = createActionsHook(store);
